import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*() {
  return yield oncallFetch("/api/oncall/partners/contact-details/get", {});
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/contact-details/get.js